import { IntlShape } from 'react-intl';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
// @ts-ignore
import optionSVG from '@plone/volto/icons/option.svg';
import DecisionAidSchema from './schema';
import View from './View';

interface Props {
  intl: IntlShape;
  selected: boolean;
  onChangeBlock: (block: string, data: {}) => {};
  block: string;
  data: {
    title: string;
    description: string;
    decision_tree: string;
  };
}

const Edit: React.FC<Props> = (props) => {
  const schema = DecisionAidSchema(props.intl);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={optionSVG} />}
          onChangeField={(id: string, value: string) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View data={props.data} isEditMode={true} />
    </>
  );
};

export default Edit;
